/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Edit_Dialog_DescriptionInputs */

const en_clients_edit_dialog_description = /** @type {(inputs: Clients_Edit_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the client's information.`)
};

const pt_br2_clients_edit_dialog_description = /** @type {(inputs: Clients_Edit_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize as informações do cliente.`)
};

/**
* | output |
* | --- |
* | "Update the client's information." |
*
* @param {Clients_Edit_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_edit_dialog_description = /** @type {((inputs?: Clients_Edit_Dialog_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Edit_Dialog_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_edit_dialog_description(inputs)
	return pt_br2_clients_edit_dialog_description(inputs)
});